import { observer } from "mobx-react-lite";
import React from "react";
import type PaymentBankTransferDetailViewModel from "viewModels/finance/payments/bankTransfer/paymentBankTransferDetailViewModel";
import BaseInfo from "./section/baseInfoView";
import IdentifiersInfo from "./section/identifiersInfoView";
import CounterpartiesInfo from "./section/counterpartiesInfoView";
import OperatingDataInfo from "./section/operatingDataInfoView";

export interface SectionWrapperProps {
  vm: PaymentBankTransferDetailViewModel;
}

const SectionWrapper = observer((props: SectionWrapperProps) => {
  const { vm } = props;

  return (
    <>
      <div className="mb-4">
        <BaseInfo vm={vm} />
      </div>
      <div className="mb-4">
        <IdentifiersInfo vm={vm} />
      </div>
      <div className="mb-4">
        <CounterpartiesInfo vm={vm} />
      </div>
      <div className="mb-4">
        <OperatingDataInfo vm={vm} />
      </div>
    </>
  );
});

export default SectionWrapper;
